"use client";

import { useLocale } from "next-intl";
import { usePathname, useRouter } from "@/i18n/navigation";
import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";

interface LanguageSwitcherProps {
  className?: string;
}

export default function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  // const t = useTranslations("LanguageSwitcher");
  const locale = useLocale();
  const router = useRouter();
  const pathname = usePathname();

  const isAr = locale === "ar";
  const targetLocale = isAr ? "en" : "ar";
  const label = isAr ? "EN" : "AR";

  const switchLocale = () => {
    router.replace(pathname, { locale: targetLocale });
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={switchLocale}
      className={cn("h-10 px-3 gap-2 font-medium rounded-xl transition-colors", className)}
    >
      <Globe className="h-4 w-4" />
      <span>{label}</span>
    </Button>
  );
}

